export default "__VITE_ASSET___TfZoDRx__"